export enum EntityType {
  individual = 'A11AE016-8E6E-4341-A4E7-D1848967897B',
  sysUser = '6D6C84AF-A441-40C3-9C95-353083BE6A3F',
  sysGroup = 'C79ABEDF-DB9B-442E-BF5A-8DA045AAED22',
  emailCommunication = '86D61022-5468-497F-A535-8329B45A84CA',
  surveyRun = '406A29F3-03F6-406C-9BEE-6F2D71667322',
  survey = '4A324E80-95F8-40C9-986C-7C2628D5C69C',
  surveyQuestion = 'B5187A65-1710-4691-A9D5-2D9D89F420E6',
  questionResponse = '7D9B7D23-4BE7-4B66-860D-AFA5B18AC3D3',
  responseHeader = '651326FB-ED87-4311-B997-AA80057D455A',
  response = '46427467-1FB0-4FD9-85FC-38DC910D10D4',
  lookup = 'd88db033-d427-4e9f-96f6-39a468caa5d6',
  emptyEntityId = '00000000-0000-0000-0000-000000000000',
  securityProfile = '5CE6CDDF-19F1-478C-ABED-04709EB892D2',
  securityTotpSecret = 'CFC3E99F-7388-4602-A3C4-F2C054A71EE1',
  securityTrustedDevices = 'F03E0580-BBA2-47DC-9820-0AC99D6C1DC0',
  securityPassKeys = 'B1B4FE94-9D69-457E-9760-2D026F2DC683',
  globalConfiguration = '8E730411-DAE7-4543-A5C1-01E183A659E1',
}
